import expect from '@block/config/expect';
const merchant: any = {
  // 获取用户账号信息
  // 接口地址是正确的，即/api/certification/account-info，git commit的message写错成/api/certification/vaccount-info
  getAccountInfo: [
    'get',
    '/api/certification/account-info',
    {
      expect: (res: any) => _.isObject(res),
      initialVal: {},
    },
  ],
  // 获取用户实名信息
  getCIPInfo: [
    'get',
    '/api/certification/cip-info',
    {
      expect: (res: any) => _.isObject(res),
      initialVal: {},
    },
  ],
  // 获取用户基本信息
  getBaseInfo: [
    'get',
    '/api/user',
    {
      expect: (res: any) => _.isObject(res),
      initialVal: {},
    },
  ],
  // 获取cip状态
  getCIP: [
    'get',
    '/api/certification/review/cip',
    {
      expect: (res: any) => _.isObject(res),
      initialVal: {},
    },
  ],
  // 获取token
  authExchangeToken: [
    'POST',
    '/api/user/web/auth/exchange_token',
    {
      expect: (res: any) => _.isObject(res),
      initialVal: {},
    },
  ],
};

export default merchant;
